import GlobalsStoreModule from '@app/store/modules/GlobalsStoreModule';
import MapTransform from '@app/transforms/MapTransform';
import AbstractSlideTransform from '@app/transforms/slides/AbstractSlideTransform';
import ITrain from '@app/types/base/ITrain';
import ITransformedTrain from '@app/types/data/base/ITransformedTrain';
import ITrainRouteSlideData from '@app/types/data/slides/ITrainRouteSlideData';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import { Entry } from 'contentful';
import { getModule as getStoreModule } from 'vuex-module-decorators';

/**
 * Transform for 004-TrainRouteSlide
 */
export default class TrainRouteSlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'TrainRouteSlide';

	public async transform(slide: ISlideMaster): Promise<ITrainRouteSlideData> {
		const globalsStore: GlobalsStoreModule = getStoreModule(GlobalsStoreModule);

		// TODO see offer slides and how they base on AbstractOfferSlideTransform (...(await super.transform(slide)),)
		const data: ITrainRouteSlideData = {
			id: slide.id,
			label: slide.fields.label,
			shareViewSection: slide.fields.shareViewSection === 'special-info' ? 'special-info' : undefined,
			thumbnail: this.extractThumbnail(slide.fields.headline, slide, 'image'),
			trains: slide.fields.trains.map((trainEntry: Entry<any>): ITransformedTrain => {
				// Get already existing ITrain from Store instead of transforming entry again
				const train: ITrain = globalsStore.trains.find(
					// eslint-disable-next-line @typescript-eslint/no-shadow
					(train: ITrain): boolean => train.id === trainEntry.sys.id // eslint-disable-line no-shadow
				) as ITrain;

				return {
					...train,
					operatingTimes: AbstractSlideTransform.parseOperatingTimes(train.operatingTimes, 'train'),
					image: train.image
						? this.transformImageAsset(train.image, {
								width: 392, // eslint-disable-line
								height: 504, // eslint-disable-line
								crop: 'limit' // eslint-disable-line
						  })
						: undefined
				};
			}),
			image: this.transformImageAsset(slide.fields.image?.fields.asset ?? this.getFallbackImage(), {
				width: 5000,
				height: 5000,
				crop: 'limit'
			}),
			map: MapTransform.getSvg(slide.fields.map) as string,
			mapLabels: AbstractSlideTransform.getMapLabels()
		};

		return data;
	}
}
